import React from 'react';
import { Form, Field } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import Button, {
  buttonTypes,
  buttonSizes,
  buttonTextSizes,
  buttonFunctions,
} from '../../shared/Button';
import { submitText } from '../../shared/SharedInternationalizations';
import { HelpWithIcon } from '../../shared/HelpIcon';
import { required } from '../../../utilities/general';

export const TableField = () => {
  const helpInfo = {
    helpId: 'AsciiRepairForm.TableHelpText',
    text: 'The database table name for repairing',
  };
  return (
    <div className="form__item-container">
      <div className="align-center">
        <label
          className="text-medium text-bold form-item__field-message--required"
          htmlFor="Table">
          <FormattedMessage
            id="AsciiRepairForm.TableInputLabel"
            defaultMessage="Table:"
            description="Enter table name"
          />
        </label>
        <HelpWithIcon {...helpInfo} />
      </div>
      <Field
        className="form-item__field"
        name="Table"
        component="input"
        validate={required}
      />
    </div>
  );
};

export const FieldName = () => {
  const helpInfo = {
    helpId: 'AsciiRepairForm.FieldHelpText',
    text: 'The field name in the table for converting from non-ascii to ascii',
  };
  return (
    <div className="form__item-container">
      <div className="align-center">
        <label
          className="text-medium text-bold form-item__field-message--required"
          htmlFor="FieldName">
          <FormattedMessage
            id="AsciiRepairForm.FieldInputLabel"
            defaultMessage="Field:"
            description="Enter field name"
          />
        </label>
        <HelpWithIcon {...helpInfo} />
      </div>
      <Field
        className="form-item__field"
        name="FieldName"
        component="input"
        validate={required}
        data-test="asciir-FieldName-input"
      />
    </div>
  );
};

export const DryrunField = () => {
  return (
    <div className="content-display__column">
      <div className="align-center">
        <Field
          id="dryrun"
          className="visually-hidden"
          name="dryrun"
          component="input"
          type="checkbox"
          data-test="fkr-dryrun-input"
          disabled={false}
        />
        <label
          htmlFor="dryrun"
          className="text-medium text-light text-deep-blue form-item__field-toggle">
          <FormattedMessage
            id="AsciiRepairForm.DryRunInputLabel"
            defaultMessage="Commit changes to database"
            description=""
          />
        </label>
      </div>
    </div>
  );
}

const AsciiRepairForm = (props) => {
  const { onSubmit } = props;

  {/* MAIN */}
  return (
    <React.Fragment>
      <Form
        data-test="ascii-repair-form"
        onSubmit={onSubmit}
        render={({
          handleSubmit,
          pristine,
          invalid,
          reset,
          submitting,
          values,
        }) => (
          <form onSubmit={handleSubmit} className="width-100">
            {/* -- Table and Field */}
            <div className="form__section-container form__section-container--grid margin-bottom-25">
              <TableField />
              <FieldName />
            </div>

            {/* DryrunField */}
            <div className="form__section-container form__section-container--grid">
              <div className="content-display__column">
                <DryrunField />
              </div>
            </div>

            <div className="form__section-container form__section-container--spread">
              <div className="form__items-group-container" />
              <div className="form__items-group-container">
                <Button
                  buttonFunction={buttonFunctions.submit}
                  text={submitText}
                  buttonType={buttonTypes.success}
                  buttonSize={buttonSizes.small}
                  buttonTextSize={buttonTextSizes.mediumSmall}
                  additionalStyles="no-margin margin-left-15"
                  disabled={pristine || invalid}
                />
              </div>
            </div>
          </form>
        )}
      />
    </React.Fragment>
  );
};

export default AsciiRepairForm;
